import { HtmlHTMLAttributes, memo } from "react";
import { AvailableFonts, AvailableFontsArray } from "../fonts";
import { SignatureCard } from "../SignatureCard";

import styles from "./styles.module.scss";

export type SignatureCardSelectorProps = HtmlHTMLAttributes<HTMLDivElement> & {
  name?: string
  optionText?: string
  hasError?: boolean
  errorText?: string | null
  disabled?: boolean
  value?: AvailableFonts | null,
  onChange?: (v: AvailableFonts | null) => void
}

export const SignatureCardSelector = memo<SignatureCardSelectorProps>((
  {
    hasError,
    optionText,
    errorText,
    disabled,
    value,
    onChange,
    name,
    ...props
  }) => {
  return (
    <div {...props}>
      {AvailableFontsArray.map(x => (
        <button
          name={name}
          type="button"
          disabled={disabled}
          data-active={x === value}
          className={styles.option}
          onClick={() => onChange?.(x)}
        >
          <SignatureCard font={x}>
            {optionText || x}
          </SignatureCard>
        </button>
      ))}
    </div>
  );
});

export default SignatureCardSelector;